export class Tabs {
    tabButton = '.js-tabs-button';
    tab = '.js-tabs-tab';

    onTabButtonClick = (el) => {
        const clickedButton = $(el.currentTarget);
        const tabName = clickedButton.data("open-tab");

        if (tabName == this.currentTab) return;

        this.tabButtons.removeClass('active');
        clickedButton.addClass('active')

        $.each(this.tabs, (index, element) => {
            console.log(index);

            if ($(element).data("tab") === tabName){
                $(`${this.tab}:visible`).fadeOut("slow", function () {
                    $(element).fadeIn("slow");
                });
            }
        });

        this.currentTab = tabName;
    }

    constructor(node){
        this.node = $(node);
        this.currentTab = '';

        this.tabButtons = this.node.find(this.tabButton);
        this.tabs = this.node.find(this.tab);

        this.tabButtons.on('click', this.onTabButtonClick);
    }
}



// WEBPACK FOOTER //
// ./app/scripts/shared/Tabs.js